import { Button } from "@/components/ui/baseUi/button"
import { StandardInput } from "@/components/ui/forms/standardInput"
import { type SimpleFormik } from "@/typings/formik"
import checkImage from "@images/svgIcons/checkIcon.svg"
import { type ProfileRegisterFormikType, type ProfileRegisterInputKey } from "@modules/auth/profileRegisterFormikTypes"
import { word } from "@modules/core/utils/i18n"
import { ArrowLeft } from "lucide-react"
import { Text } from "@/components/ui/baseUi/text"
import { cn } from "@/modules/lib/utils"

export type RegisterFormOnePageProps = {
  handleSubmit: () => void
  onPrevious: () => void
  formik: SimpleFormik<ProfileRegisterFormikType, ProfileRegisterInputKey>
  getFormErrorMessage: (name: ProfileRegisterInputKey, errorMessage?: string) => React.JSX.Element | undefined
  disabled: boolean
  className?: string
} & React.ComponentProps<"div">

export function RegisterFormOnePage({
  handleSubmit,
  onPrevious,
  formik,
  getFormErrorMessage,
  disabled,
  className,
}: RegisterFormOnePageProps) {
  return (
    <div className={cn("flex grow flex-col justify-between gap-4", className)}>
      <div className="relative flex grow flex-col justify-between gap-4">
        <Button variant="ghost" size="xs" onClick={onPrevious} className="w-fit justify-start">
          <ArrowLeft />
          {word("global.previous")}
        </Button>

        <img src={checkImage} width={100} className="absolute top-[-8%] right-0" alt="check" />

        <Text fontStyle="TM">1/4</Text>
        <Text fontStyle="TM">{word("auth.signup.form.page.1.title")}</Text>
        <Text fontStyle="BS" color="--neutral-700">
          {word("auth.signup.form.page.1.description")}
        </Text>

        {/* FIRSTNAME */}
        <StandardInput
          inputProps={{
            placeholder: word("auth.signup.form.first_name"),
          }}
          isRequiredInput
          getFieldProps={formik.getFieldProps}
          name="firstname"
          error={getFormErrorMessage("firstname")}
          setFieldValue={formik.setFieldValue}
        />

        {/* LASTNAME */}
        <StandardInput
          inputProps={{
            placeholder: word("auth.signup.form.last_name"),
          }}
          isRequiredInput
          getFieldProps={formik.getFieldProps}
          name="lastname"
          error={getFormErrorMessage("lastname")}
          setFieldValue={formik.setFieldValue}
        />
      </div>

      <Button type="button" size="lg" variant="primary" onClick={handleSubmit} disabled={disabled}>
        {word("global.next")}
      </Button>
    </div>
  )
}
